export const educationData = [
  {
    id: 1,
    institution: "Scholars Rosary Sr. Sec. School",
    course: "Higher Secondary Education",
    startYear: "2005",
    endYear: "2018",
  },
  {
    id: 2,
    institution: "Ganga International School, New Delhi",
    course: "Higher Secondary Education",
    startYear: "2018",
    endYear: "2020",
  },
  {
    id: 3,
    institution: "Vellore Institute of Technology, Vellore",
    course:
      "B.Tech. in Computer Science and Engineering with Specialization in Information Security",
    startYear: "2020",
    endYear: "Present",
  },
];
